module.exports = __webpack_public_path__ + "img/Hide Icon - white.f20d0156.svg";